import { ModalState } from 'containers/Common/ModalStateFactory';
import { L1Object } from 'core/l1Object/L1Object';
import i18n from 'i18n';
import { DraftSummaryStateContent } from './DraftSummaryStateContent';
import { DefaultDraftSummaryStateContentModel } from './DraftSummaryStateContentModel';
import { ChannelGroupSetting } from 'core/channelGroup/ChannelGroupSettings';

export class DraftSummaryState implements ModalState {
  back?;
  next?;
  close?;
  contentModel: DefaultDraftSummaryStateContentModel;
  channelGroupSetting: ChannelGroupSetting;

  constructor(
    protected l1Object: L1Object,
    protected l2ObjectsToCreateDraft: {
      id: number | string;
      isDraft: boolean;
    }[]
  ) {
    this.next = async () => {
      await this.contentModel.save();
      this.close && this.close(true);
    };
    this.contentModel = this.getContentModel();
    this.channelGroupSetting = ChannelGroupSetting.fromId(
      l1Object.channelGroupId
    );
  }

  get title() {
    return this.titleFormatter(
      i18n.t('draftCreateModal.titles.duplicate', {
        l2Object: i18n.t('draftCreateModal.titles.target', {
          channel: this.channelGroupSetting.config.name
        }),
        number: this.l2ObjectsToCreateDraft.length
      })
    );
  }

  titleFormatter = (title) => {
    if (i18n.language === 'en' && this.l2ObjectsToCreateDraft.length > 1) {
      return (title = title + 's');
    }
    return title;
  };

  getContentModel = (): DefaultDraftSummaryStateContentModel => {
    return new DefaultDraftSummaryStateContentModel(
      this.l1Object.channelGroupId
    );
  };

  get content() {
    return DraftSummaryStateContent;
  }

  get btnData(): any {
    return {
      primaryButton: this.next && {
        title: i18n.t('draftCreateModal.buttons.createDraft'),
        callback: this.next
      },
      secondaryButton: this.back && {
        title: i18n.t('common.buttons.backModify'),
        callback: this.back
      },
      dangerButton: this.close && {
        title: i18n.t('common.buttons.cancel'),
        callback: () => {
          this.close(false);
        }
      }
    };
  }

  canGoNext = () => {
    return this.contentModel.canGoNext;
  };
}
